import './DashboardContainer.scss';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';
import { IUserStore } from '../../../__legacy__/modules/user/user.store';
import { SideNavigation } from '../../sideNavigation/SideNavigation';
import { ISideNavigationStore } from '../../sideNavigation/SideNavigation.store';
import { TopNavigation } from '../../topNavigation/TopNavigation';
import { ICurrentWorkspaceStore } from '../../workspaces/currentWorkspace/CurrentWorkspace.store';

interface IProps {
  className?: string;
}

export const DashboardContainer = observer((props: PropsWithChildren<IProps>): ReactElement => {
  const userStore = useInjection(IUserStore.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const sideNavigationStore = useInjection(ISideNavigationStore.$);

  const toggleSideNavigationExtend = (): void => {
    sideNavigationStore.isExpanded = !sideNavigationStore.isExpanded;
  };

  const workspace = currentWorkspaceStore.currentWorkspace;
  const userRole = userStore.userInfo.role;
  const isExpanded = sideNavigationStore.isExpanded;

  return (
    <div className='dashboard-container'>
      {workspace && (
        <>
          <TopNavigation />
          <div className='dashboard-content'>
            <SideNavigation
              isExpanded={isExpanded}
              handleToggleExpand={toggleSideNavigationExtend}
              userRole={userRole}
              workspaceId={workspace.id}
            />
            <div className='dashboard-inside'>
              <div className='dashboard-inside-scroll'>{props.children}</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
});
